// extracted by mini-css-extract-plugin
export default {"navBar-container":"BottomNavBar_navBar-container__OXSJZ"};